/*
* @Author: babysoft08
* @Date:   2025-06-08 15:09:03
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-19 18:39:53
*/
import React, { useState, useEffect } from 'react';
import './QualityControl.css';
import { Link } from 'react-router-dom';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import StatusModal from '../../components/Modals/StatusModal';
import infoIconImg from '../../images/info-icon-img.png';
import { Validation } from '../../validation';
import QualityControlService from './../../services/QualityControlService/QualityControlService';
class QualityControlStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fields : [],
			errors : [],
			ticket_status_message : null,
			isSubmit : false,
			isDisabled : false,
			showStatusModal : false
		}
		this.qualityControlService = new QualityControlService
	}

	handleChange(field, e){
		let { fields } = this.state; 
	    const { name, value } = e.target;
	    const newFormData = {
	        ...fields,
	        [name]: value,
	    };
	    this.setState({fields : newFormData});
	}

	handleSubmit(e) {
		e.preventDefault();
		const { fields  } = this.state;

		let errors = Validation(fields, ['ticket_number']);

		if (Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		this.setState({ errors: {} });
		this.submitForm(e);
	}

	submitForm(e) {
		e.preventDefault();
		const { fields, files, selected_part_number } = this.state;
		const formData = {
			...fields,
		};
		this.setState({isSubmit : true, isDisabled : true, api_error : null, errors : [], ticket_status_message : null});
		this.qualityControlService.checkStatus(formData).then((response) => {
			this.setState({isSubmit : false, isDisabled : false });
			if(response.data.status === 'success') {
				this.setState({ticket_status_message : response.data.message});
			} else {
				this.setState({
					errors: {
						...this.state.errors,
						api_error: response.data.message || 'Something went wrong. Please try again.',
					},
				});

			}

		});
	}



	render() {
		let { errors, ticket_status_message, isSubmit, isDisabled, showStatusModal } = this.state;
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					<section className="techtop-report-quality-issue-section">	
						<div className="container">
							<div className="row">																 
								<div className="col-md-8 offset-md-2">	
									<div className="card">
										<div className="row" id="">																 
											<form className="techtop-report-quality-issue-form" onSubmit={this.handleSubmit.bind(this)}>
												<div className="col-md-12 mt-3">
													<h4 className="text-center">Check Ticket Status</h4>
													<div className="mb-3">
														<input className="form-control" type="text" id="ticket_number" name="ticket_number" placeholder="Enter Ticket Number (e.g., QC-202506041200-123)" ref="ticket_number" onChange={this.handleChange.bind(this, 'ticket_number')} value={this.state.fields['ticket_number'] || ''}/>
														{errors.ticket_number && <div className="text-danger">{errors.ticket_number}</div>}
													</div>
													{(isSubmit) && <GearSpinner/>}
													{ticket_status_message !== null && (
													  <div className="text-center mb-3">
													    <h4>{ticket_status_message}</h4>
													  </div>
													)}
													{errors.api_error && <div className="text-center text-danger mb-3">{errors.api_error}</div>}

													<button type="submit" className="btn check-status-btn" disabled={isDisabled}>Check Status</button>
													<div id="statusResult"></div>
												</div>
												<div className="form-footer-link text-center mt-2">
													<p className="m-0"><a href="/quality-control">Submit issue</a></p>
													<p className="m-0"><a href="#">QC Team Login</a></p>
													<Link to={'#'} class="techtop-info-icon" onClick={() => this.setState({showStatusModal : true})}><img src={infoIconImg} alt="info-icon" /></Link>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<StatusModal isShow={showStatusModal} onClose={() => this.setState({showStatusModal : false})}/>
				</main>
			</React.Fragment>
		)
	}

}

export default QualityControlStatus;